import { cn } from '#components/utils.js'

export function Card({ className, ...props }) {
  return (
    <div
      className={cn(
        'flex flex-col gap-6 rounded-lg border bg-card py-6 text-card-foreground shadow-xs',
        className,
      )}
      data-slot='card'
      {...props}
    />
  )
}

export function CardHeader({ className, ...props }) {
  return (
    <div
      className={cn('grid gap-1.5 px-6', className)}
      data-slot='card-header'
      {...props}
    />
  )
}

export function CardTitle({ as: Component = 'h3', className, ...props }) {
  return (
    <Component
      className={cn('font-semibold leading-snug tracking-tight', className)}
      data-slot='card-title'
      {...props}
    />
  )
}

export function CardDescription({ className, ...props }) {
  return (
    <p
      className={cn('text-sm text-muted-foreground', className)}
      data-slot='card-description'
      {...props}
    />
  )
}

export function CardContent({ className, ...props }) {
  return (
    <div
      className={cn('px-6', className)}
      data-slot='card-content'
      {...props}
    />
  )
}

export function CardFooter({ className, ...props }) {
  return (
    <div
      className={cn('flex items-center px-6', className)}
      data-slot='card-footer'
      {...props}
    />
  )
}
